/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssetDataComplianceDto } from './assetDataComplianceDto';
import { AccountComplianceDto } from './accountComplianceDto';

/**
 * Volume statistic compliance dto
 */
export interface VolumeStatisticComplianceDto {
  account: AccountComplianceDto;
  volumeInUsd: number;
  fullyHedged: boolean;
  assetData: Array<AssetDataComplianceDto>;
}
